import { useNavigate } from 'react-router-dom';
import { Button, Divider, Flex, Text } from '@mantine/core';
import { GlobalDocumentTemplateRes } from '@dealstack/shared/lib/generated';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { MANAGE_DOCUMENT_TEMPLATES_ROUTES } from '@dealstack/frontend/app/pages/DocumentTemplates/ManageDocumentTemplates.routes';
import { documentTemplatesTableColumns } from './documentTemplatesTable.columns';
import { useDocumentTemplatesTable } from './useDocumentTemplatesTable';
import { PageHeader } from './DocumentTemplatesTable.styled';

export const DocumentTemplatesTable = () => {
	const navigate = useNavigate();

	const { tableData, isLoading, mantineTableDataOperations } = useDocumentTemplatesTable();

	return (
		<div>
			<PageHeader>
				<Button
					size="sm"
					variant="outline"
					onClick={() => navigate(ROUTES.DASHBOARD)}
					leftSection={<Icon variant="arrow-left" />}
				>
					Back to dashboard
				</Button>

				<Flex gap="2rem" align="center" justify="space-between" mt="1rem">
					<Text size="B4Bold">Manage document templates</Text>
					<Button
						size="md"
						variant="primary"
						onClick={() =>
							navigate(
								`${ROUTES.TEMPLATES}/${MANAGE_DOCUMENT_TEMPLATES_ROUTES.CREATE}`
							)
						}
					>
						Add new document template
					</Button>
				</Flex>

				<Divider mt="1rem" mb="1rem" />
			</PageHeader>
			<MantineTable<GlobalDocumentTemplateRes>
				getRowId={(row) => row.id}
				isLoading={isLoading}
				data={tableData}
				columns={documentTemplatesTableColumns}
				rowCount={tableData.length}
				dataOperations={mantineTableDataOperations}
				manualPagination={false}
				manualFiltering={false}
				manualSorting={false}
				enableRowSelection={false}
				renderBulkActionsMenu={false}
			/>
		</div>
	);
};
